import React, {useCallback} from 'react'

import {useDispatchTeamEvent} from '@daedalus/core/src/analytics/hooks/useDispatchTeamEvent'
import {trackEvent} from '@daedalus/core/src/analytics/modules/actions'
import {TrackEventPayload} from '@daedalus/core/src/analytics/types/Events'

import {useOsanoCookieConsent} from './useOsanoCookieConsent'

export interface CookieConsentBannerProps {
  /**
   * Callback invoked when a user accepts the cookies, either in the
   * banner or the preference center
   */
  onAccept?: (acceptedByUser: boolean) => void
  trackEvent: (payload: TrackEventPayload) => void
}

export const shouldCookieBannerBeShown = (): boolean =>
  window.Osano?.cm?.dialogOpen ?? false

export const CookieConsentBanner = ({
  onAccept,
  trackEvent
}: CookieConsentBannerProps) => {
  useOsanoCookieConsent({
    onAccept,
    trackEvent
  })

  return null
}

export const CookieConsentBannerWithStore = (
  props: Omit<CookieConsentBannerProps, 'trackEvent'>
) => {
  const dispatchTeamEvent = useDispatchTeamEvent()
  const trackEventCallback = useCallback(
    (payload: TrackEventPayload) => dispatchTeamEvent(trackEvent(payload)),
    [dispatchTeamEvent]
  )
  return <CookieConsentBanner {...props} trackEvent={trackEventCallback} />
}
